import { createFileRoute } from '@tanstack/react-router'
import { Suspense } from 'react'
import { InviteAccept } from '@/components/auth/invite/invite-accept'
import GenieLogo from '@/components/ui/icon/icons/GenieLogo'

export const Route = createFileRoute('/_auth/invite/$slug')({
  component: InvitePage,
})

function InvitePage() {
  const { slug } = Route.useParams()

  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center">
          <div className="text-center flex flex-col items-center">
            <GenieLogo className="mb-6 h-12 w-12" />
            <p className="mb-4">Loading invite...</p>
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground"></div>
          </div>
        </div>
      }
    >
      <InviteAccept slug={slug} />
    </Suspense>
  )
}
